import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { environment } from './environments/environment'
import { AppComponent } from './app/app.component'
import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'

if (environment.production) {
    enableProdMode()
    if (window) {
        window.console.log = () => {
        }
        window.console.error = () => {
        }
    }
}

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
    .catch(err => console.error(err))
